import { atom } from "jotai";

export const staffVisionEnabledAtom = atom<boolean>(false);